import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import { Store } from "../../context/Store";

import CloseModalIcon from "../../assets/Images/Mobile/CloseModal.png";

import {
  DarkBackground,
  Modal,
  ModalHeader,
  CloseModalButton,
  ModalBody,
  ModalButtons,
  ModalButtonOne,
  ModalButtonTwo,
} from "./ErrorModalStyles";

const ErrorModal: React.FC = () => {
  let navigate = useNavigate();
  const { getTranslation } = useContext(LanguageContext);
  const { state, dispatch } = useContext(Store);
  const { errorType, scene } = state;

  // Update context in order to close Modal
  const closeErrorModal = (event: string) => {
    dispatch({
      type: "CLEAR_ERROR",
    });
    switch (event) {
      case "StartAgain":
        navigate("/");
        break;
      case "StartVideo":
        const videoEl = document.getElementById("dp-video") as HTMLVideoElement;
        videoEl.playsInline = true;
        videoEl.autoplay = true;
        videoEl.muted = false;
        videoEl.play();
        break;
      case "ProvideFeedback":
        window.open(
          "https://www.nrma.com.au/feedback?feedback=true",
          "_blank",
          "noopener,noreferrer"
        );
        navigate("/");
        break;
      default:
        navigate("/");
        break;
    }
  };

  const closeButton = () => {
    dispatch({
      type: "CLEAR_ERROR",
    });
    navigate("/");
  };

  // We pass the errorType into our translation context

  return (
    <>
      <DarkBackground onClick={() => closeButton} />
      <Modal>
        <ModalHeader>
          <CloseModalButton onClick={closeButton}>
            <img src={CloseModalIcon} alt="Close Modal Button" />
          </CloseModalButton>
          <h3>{getTranslation(errorType?.headerText)}</h3>
        </ModalHeader>
        <ModalBody>
          <p>{getTranslation(errorType?.bodyText)}</p>
        </ModalBody>
        <ModalButtons>
          <ModalButtonOne
            onClick={() => {
              if (errorType) closeErrorModal(errorType.buttonText.one);
            }}
          >
            {getTranslation(errorType?.buttonText.one)}
          </ModalButtonOne>
          {errorType?.buttonText.two !== "" && (
            <ModalButtonTwo
              onClick={() => {
                if (errorType) closeErrorModal(errorType.buttonText.two);
              }}
            >
              {getTranslation(errorType?.buttonText.two)}
            </ModalButtonTwo>
          )}
        </ModalButtons>
        {errorType?.error && errorType.error}
      </Modal>
    </>
  );
};

export default ErrorModal;
